import { Component, OnInit } from '@angular/core';
import {VnaClientService} from '../../service/vna-client.service';
import {ModalService} from 'ngx-dynamic-modal';
import {EditVnaClientModalComponent} from '../../modals/edit-vna-client-modal/edit-vna-client-modal.component';
import {AlertaService} from '../../../../shared/services/alerta.service';


@Component({
  selector: 'app-vna-client-list',
  templateUrl: './vna-client-list.component.html',
  styleUrls: ['./vna-client-list.component.scss']
})
export class VnaClientListComponent implements OnInit {

  clients: Array<Object>=[];
  enabled:boolean;

  constructor(private clientHandler: VnaClientService,
              private modalHandler: ModalService,
              private alerta:AlertaService) { }

  ngOnInit() {
      this.getClientList();
  }

  getClientList(){
        this.enabled=true;
        this.clientHandler.getClientList()
            .subscribe( result => {
                this.clients=result;
            }, error => {
                console.log(error);
            }, () =>{
                this.enabled=false;
            })
  }

  openModal(element=null){
        this.modalHandler.addDynamicComponent(EditVnaClientModalComponent, {element}, (res) => {
            this.getClientList();
        });
  }

  deleteClient(client){
        this.alerta.addAlert('confirm','Do you want to Delete client?')
            .then((result)=>{
                if(result.value){
                    this.clientHandler.removeClient(client.pk)
                        .subscribe( result => {
                        }, error => {
                            console.log(error);
                            this.alerta.addAlert('error','Something went wrong!!')
                        }, () => {
                            this.alerta.addAlert('success','Client Deleted Succesfully!!')
                            let indx=this.clients.indexOf(client);
                            this.clients.splice(indx,1);
                        })}
            })
  }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/client/management/components/vna-client-list/vna-client-list.component.ts